import { ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastService } from '@capturum/ui/api';
import { CapturumInputModule } from '@capturum/ui/input';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { interval, take } from 'rxjs';

@Component({
  selector: 'app-formly-password-type',
  imports: [FormlyModule, FormsModule, ReactiveFormsModule, CapturumInputModule, TranslateModule],
  templateUrl: './formly-password-type.component.html',
  styleUrl: './formly-password-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FormlyPasswordTypeComponent extends FieldType {
  public isPasswordTypeText = signal(false);
  public override defaultOptions = {
    props: {
      hideIcon: 'mynaui-eye-off',
      showIcon: 'mynaui-eye',
      autocomplete: 'off',
      toggleMask: false,
      enableCopy: false,
      autoCloseTimeout: 1500,
    },
  };

  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);

  public displayToggle(): void {
    this.isPasswordTypeText.update((value) => {
      return !value;
    });

    if (this.props.autoCloseTimeout && this.isPasswordTypeText()) {
      interval(this.props.autoCloseTimeout)
        .pipe(take(1))
        .subscribe(() => {
          this.isPasswordTypeText.set(false);
        });
    }
  }

  public onInputEvent($event: Event): void {
    this.formControl.markAsTouched();

    this.props.onInput?.($event);
  }

  public onBlur($event: Event): void {
    this.formControl.markAsTouched();

    this.props.onBlur?.();
  }

  public onFocus($event: Event): void {
    this.props.onFocus?.();
  }

  public onKeyUp($event: KeyboardEvent): void {
    this.props.onKeyUp?.($event);
  }

  public async copyPassword(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.formControl.value);

      this.toastService.success(
        this.translateService.instant('general.success'),
        this.translateService.instant('general.copy-to-clipboard-success'),
      );
    } catch (error) {
      console.error(error);
    }
  }
}
